// Maximum length (in characters) of a skill's agent-facing description.
export const AGENT_FACING_DESCRIPTION_MAX_LENGTH = 1_000;

export const SKILL_INVOCATION_LABEL = "When to use this skill";
export const SKILL_INSTRUCTIONS_LABEL = "Instructions";
